// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'
import usePathCartDrawerContext from 'components/PathCart/hooks/usePathCartDrawerContext'
import { PathCartToggleWrapper } from './styles'

const PathCartToggle = ({ idRoot }) => {
  const [pathCartIsActive, togglePathCartIsActive] = usePathCartDrawerContext()

  return (
    <PathCartToggleWrapper
      className={'bg-white text-blue-dark pointer'}
      disabled={pathCartIsActive}
      id={`${idRoot}-path-cart-drawer-toggle`}
      onClick={togglePathCartIsActive}
      type={'button'}>
      <i className={'fa fa-2x fa-bars'} />
    </PathCartToggleWrapper>
  )
}

PathCartToggle.propTypes = {
  idRoot: string.isRequired,
}

export default PathCartToggle
